// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"b1d16f59","598":"caa41dd0","703":"15aedf80"}[chunkId] + ".chunk.js";
};